export const environment = {
  production: false,
  apigee: {
    host: "https://api.dev.aritzia.com",
    banner: "Aritzia_CA",
    inboundPath: "/concierge/events/inbound",
    deletionPath:"/pubsub/publish/message/atz-retail-concierge-dev/delete-employee-events",
    outboundPath: "/concierge/events/outbound",
    tokenPath: "/oauth2/token"
  },
  azure: {
    redirectUri: "https://cti.dev.aritzia.com",
    graphApi: "https://graph.microsoft.com/v1.0/me?$select=employeeId"
  },
  ctiTargetOrigin: "https://my346364-sso.crm.ondemand.com",
  DataDogEnv: 'dev'
}
